export const events = {
  eventsCardDurationText: 'Varaktighet',
  eventsSearchInputText: 'Sök',
  eventsRegisteredToEventAlertTitle: 'Registrerad framgångsrikt',
  eventsUnregisteredToEventAlertTitle: 'Avregistrerad framgångsrikt',
  eventsExternalRegistrationPopupTitle: 'Registrera',
  eventsExternalRegistrationPopupContent: 'Har du registrerat dig framgångsrikt?',
  eventsExternalRegistrationNoButtonTitle: 'Nej',
  eventsExternalRegistrationYesButtonTitle: 'Ja',
  eventsCurtainCopyOptionTitle: 'Kopiera länk',
  eventsCurtainFlagOptionTitle: 'Rapportera innehåll',
  eventsLinkCopiedAlertText: 'Länk kopierad!',
  eventsCurtainAddToCalendOptionTitle: 'Lägg till i kalender',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'På karta',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Deltagare',
  eventdetailsSeeAllButtonTitle: 'Se alla',
  eventdetailsRegisteredButtonTitle: 'Registrera',
  eventdetailsRegisterButtonTitle: 'Registrera',
  eventdetailsRegisteredAlertText: 'Registrerad framgångsrikt',
  eventdetailsUnregisteredAlertText: 'Avregistrerad framgångsrikt',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Registrerade användare',
  eventdetailsSpeakersCurtainTitle: 'Talare',
  eventdetailsSpeakersSectionTitle: 'Talare',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Se alla',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Se alla',
  eventdetailsCurtainCopyOptionTitle: 'Kopiera länk',
  eventdetailsCurtainFlagOptionTitle: 'Rapportera innehåll',
  eventsdetailsLinkCopiedAlertText: 'Länk kopierad!',
  eventdetailsCurtainAddToCalOptionTitle: 'Lägg till i kalender',
  eventDetailsAddCalendarPopupTitle: 'Kalender',
  eventdetailsAddCalendarPopupContent: 'Lägg till i Kalender?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Nej',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Ja',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Kopiera länk',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Rapportera innehåll',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Länk kopierad!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Kopiera länk',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Rapportera innehåll',
  eventsFlag: 'Rapportera',
  eventsJoin: 'Gå med',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Länk kopierad!',
  eventContentReported: 'Innehåll rapporterat',
  eventsError: 'Något gick fel!',
  eventdetailsExternalRegistrationPopupContent: 'Har du registrerat dig framgångsrikt?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Nej',
  eventdetailsExternalRegistrationYesButtonTitle: 'Ja',
  eventdetailsExternalRegistrationPopupTitle: 'Registrera',
  eventsCardRegisteredButtonTitle: 'Registrerade',
  eventsCardRegisterButtonTitle: 'Registrera',
  eventsJoinLink: 'Länk för att gå med: [url]{link}[/url][br]',
  eventsGuest: 'Gäst',
  eventsNoSessionInDay: 'Inga evenemang den här dagen.',
  eventsShowUpcomingEvent: 'Visa kommande evenemang'
}
